import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card, Form, Image, Modal, Popconfirm, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { MessagesService } from "services/Messages";
import initial_filter from "constants/InitialFilter";
import { mainUrl } from "api/mainApiInstence";
import { FormComponent } from "./components/FormComponent";
import { CategoryApi } from "api/CategoryApi";

export default function Category() {
  // Table columns
  const columns = [
    {
      title: "Название категории",
      width: 100,
      dataIndex: "name",
      key: "name",
      fixed: "left",
    },
    {
      title: "Фото",
      width: 130,
      dataIndex: "photo",
      key: "photo",
      render: (record, _) => {
        return (
          <Image
            src={mainUrl() + "/files/" + record}
            className="rounded-lg"
            style={{
              height: "150px",
              objectFit: "contain",
            }}
          />
        );
      },
    },
    {
      title: "Действия",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (record) => {
        return (
          <Row className="items-start flex-col">
            <Button
              type="primary"
              ghost
              size="middle"
              onClick={() => {
                form.setFieldsValue(record);
                setFileList({
                  photo: [
                    {
                      url: `${mainUrl()}/files/${record.photo}`,
                    },
                  ],
                });
                setEdit(true);
              }}
            >
              Редактировать
              <EditOutlined />
            </Button>
            <Popconfirm
              title="Вы уверены, что хотите удалить эту категорию?"
              okText="Да"
              cancelText="Нет"
              okType="danger"
              size="middle"
              icon={<DeleteOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                onRemove(record.id);
              }}
            >
              <Button
                danger
                ghost
                icon={<DeleteOutlined />}
                size="middle"
                style={{ marginTop: 10 }}
              >
                Удалить
              </Button>
            </Popconfirm>
          </Row>
        );
      },
    },
  ];
  // States
  const [data, setData] = useState();
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [filter, setFilter] = useState(initial_filter);
  const [fileList, setFileList] = useState({
    photo: [],
  });
  const [form] = Form.useForm();

  // Get portfolios
  useEffect(() => {
    setLoading(true);
    setBtnLoading(true);
    CategoryApi.get(filter)
      .then((res) => {
        setData(res.categories);
        setBtnLoading(false);
        setLoading(false);
      })
      .catch((err) => {
        MessagesService.error(err.message);
        setLoading(false);
        setBtnLoading(false);
      });
  }, [filter]);

  // Post Pacht Delete course functions
  const onFinish = () => {
    setBtnLoading(true);
    const formData = new FormData();
    formData.append("name", form.getFieldValue().name);
    formData.append("photo", form.getFieldValue().photo.file.originFileObj);
    CategoryApi.create(formData).then((res) => {
      if (res) {
        setData([...data, res.category]);
        MessagesService.success("Категория создана");
        setOpen(false);
        form.resetFields();
        setBtnLoading(false);
      }
    });
  };
  const onEdit = () => {
    const formData = new FormData();
    setBtnLoading(true);
    formData.append("name", form.getFieldValue().name);
    if (form.getFieldValue().photo?.file?.originFileObj) {
      formData.append("photo", form.getFieldValue().photo.file.originFileObj);
    }

    CategoryApi.edit(form.getFieldValue().id, formData).then((res) => {
      if (res) {
        MessagesService.success("Категория обновлена");
        setEdit(false);
        setData(
          data.map((item) => {
            if (item.id === res.category.id) {
              return res.category;
            }
            return item;
          })
        );
        form.resetFields();
        setFileList({ photo: [] });
        setBtnLoading(false);
      }
    });
  };
  const onRemove = (id) => {
    CategoryApi.delete(id).then((res) => {
      if (res) {
        console.log(res);
        setData(data.filter((item) => item.id !== id));
        MessagesService.success("Категория удалена");
      }
    });
  };

  // Render
  return (
    <>
      <Card>
        <Row className="justify-between items-center">
          <h4 className="font-semibold text-base">Категория</h4>
          <Button
            type="primary"
            size="large"
            onClick={() => {
              setFileList({ photo: [] });
              setOpen(true);
              form.resetFields();
            }}
          >
            Создать категорию
          </Button>
        </Row>
      </Card>
      <Card>
        <Table columns={columns} dataSource={data} loading={loading} />
      </Card>
      <Modal
        title="Создать категорию"
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width={800}
        footer={null}
      >
        <FormComponent
          type="create"
          fileList={fileList}
          setFileList={setFileList}
          form={form}
          onFinish={onFinish}
          btnLoading={btnLoading}
        />
      </Modal>
      <Modal
        title="Редактировать категорию"
        centered
        open={edit}
        onOk={() => setEdit(false)}
        onCancel={() => setEdit(false)}
        footer={null}
        width={800}
      >
        <FormComponent
          type="edit"
          fileList={fileList}
          setFileList={setFileList}
          form={form}
          onFinish={onEdit}
          btnLoading={btnLoading}
        />
      </Modal>
    </>
  );
}
